import { fg } from '@confluence/feature-gating';

export const isEmojiTitleEnabled = (contentType: string | null | undefined): boolean => {
	return contentType === 'whiteboard' && fg('confluence_frontend_whiteboard_emoji_titles');
};
